import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["element"]

  connect() {
    this.observers = []
    this.elementTargets.forEach((element, index) => {
      // Return early if the current position is already past the element
      const elementRect = element.getBoundingClientRect()
      if (elementRect.bottom <= 100) {
        element.classList.add('is-visible')
        return
      }

      const threshold = element.dataset.threshold ? parseFloat(element.dataset.threshold) : 0.25
      const delay = element.dataset.delay ? parseInt(element.dataset.delay) : 100
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                entry.target.classList.add('scroll-animate')
                observer.unobserve(entry.target)
              }, delay)
            }
          })
        },
        {
          threshold: threshold
        }
      )

      observer.observe(element)
      this.observers.push(observer)
    })
  }

  disconnect() {
    if (this.observers) {
      this.observers.forEach(observer => observer.disconnect())
    }
  }
} 